// PDF Styling Configuration
export const colors = {
  primary: "#F59E0B", // Orange
  primaryDark: "#D97706", // Darker orange
  secondary: "#1F2937", // Dark gray
  purple: "#3f2b96", // Purple accent
  accent: "#10B981", // Green accent
  white: "#FFFFFF",
  lightGray: "#F9FAFB",
  mediumGray: "#6B7280",
  darkGray: "#374151",
  border: "#E5E7EB",
  shadow: "rgba(0, 0, 0, 0.1)",
};

export const fonts = {
  regular: "Helvetica",
  bold: "Helvetica-Bold",
};

export const pdfStyles = {
  // Page Styles
  page: {
    backgroundColor: colors.white,
    fontFamily: fonts.regular,
    fontSize: 10,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },

  // Header Styles
  header: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: 12,
    borderBottom: `3px solid ${colors.primary}`,
    marginBottom: 12,
  },

  // Top Header Row
  headerTop: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },

  headerLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },

  headerLogo: {
    width: 100,
    height: "auto",
    marginRight: 20,
  },

  companyInfo: {
    display: "flex",
    flexDirection: "column",
  },

  companyName: {
    fontSize: 18,
    fontFamily: fonts.bold,
    color: colors.secondary,
    marginBottom: 3,
  },

  companyTagline: {
    fontSize: 10,
    fontFamily: fonts.regular,
    color: colors.mediumGray,
    fontStyle: "italic",
  },

  headerRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    minWidth: 120,
  },

  wefDate: {
    fontSize: 9,
    color: colors.mediumGray,
    marginRight: 5,
    marginBottom: 5,
  },

  hsnInfo: {
    fontSize: 8,
    color: colors.white,
    backgroundColor: colors.purple,
    padding: "3 8",
    borderRadius: 4,
  },

  // Product Heading Section - New Design
  productHeadingSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 10,
    backgroundColor: colors.primary,
    borderRadius: 10,
    marginBottom: 3,
  },

  productHeading: {
    fontSize: 18,
    fontFamily: fonts.bold,
    color: colors.white,
    textTransform: "uppercase",
    letterSpacing: 2,
    textAlign: "center",
    marginBottom: 5,
  },

  productHeadingDescription: {
    fontSize: 9,
    color: colors.white,
    textAlign: "center",
    maxWidth: 400,
    lineHeight: 1.2,
  },

  // Content Container
  contentContainer: {
    flex: 1,
    marginTop: 6,
    marginBottom: 5,
  },

  // Content Grid Styles
  content: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 6,
  },

  // Category Card Styles
  categoryCard: {
    backgroundColor: colors.primary,
    marginBottom: 6,
    borderRadius: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    shadowColor: colors.shadow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },

  categoryTitle: {
    fontSize: 12,
    fontFamily: fonts.bold,
    color: colors.white,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 1,
    padding: 6,
    lineHeight: 1.2,
  },

  // Product Card Styles
  productCard: {
    backgroundColor: colors.white,
    marginBottom: 6,
    borderRadius: 10,
    border: `1px solid ${colors.primary}`,
    overflow: "hidden",
    position: "relative",
    shadowColor: colors.shadow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
  },

  // Image Container
  productImageContainer: {
    backgroundColor: colors.white,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: 0,
  },

  productImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    height: "auto",
    width: "auto",
    objectFit: "contain",
  },

  // watermarkImage: {
  //   position: "absolute",
  //   width: 20,
  //   height: "auto",
  //   opacity: 0.4,
  //   top: 4,
  //   right: 4,
  // },

  // Part Number (inside image area, left side)
  partNumber: {
    position: "absolute",
    left: -10,
    top: 30,
    transform: "rotate(-90deg)",
    transformOrigin: "center right",
    backgroundColor: colors.purple,
    borderRadius: 2,
    width: "auto",
    textAlign: "center",
    padding: "0 6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // Gradient Separator Line
  gradientSeparator: {
    height: 1,
    backgroundColor: colors.primary,
    marginVertical: 1,
  },

  // Product Information
  productInfo: {
    padding: 4,
    height: 32,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  productDescriptionText: {
    fontSize: 6,
    fontFamily: fonts.regular,
    textAlign: "center",
    color: colors.darkGray,
    lineHeight: 1,
    padding: "1 0",
  },

  // HSN Code Badge
  hsnCode: {
    position: "absolute",
    top: 4,
    right: 4,
    backgroundColor: colors.purple,
    color: colors.white,
    fontSize: 4,
    padding: "1 3",
    borderRadius: 2,
    fontFamily: fonts.bold,
  },

  // REDESIGNED COMPACT FOOTER
  footer: {
    background: `linear-gradient(135deg, ${colors.purple} 0%, ${colors.secondary} 100%)`,
    marginTop: "auto",
    borderRadius: 8,
    height: 40,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8 10",
    position: "relative",
    overflow: "hidden",
  },

  footerLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },

  footerCompanyName: {
    fontSize: 11,
    fontFamily: fonts.bold,
    color: colors.white,
    marginRight: 8,
  },

  footerDivider: {
    width: 1,
    height: 20,
    backgroundColor: colors.primary,
    marginHorizontal: 8,
    opacity: 0.6,
  },

  footerContactInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    gap: 3,
  },

  contactItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  contactIcon: {
    width: 8,
    height: 8,
    marginRight: 3,
    opacity: 0.9,
  },

  contactText: {
    fontSize: 7,
    color: colors.purple,
    fontFamily: fonts.regular,
  },

  footerCenter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flex: 0.6,
  },

  footerCenterImage: {
    minWidth: "30px",
    height: "30px",
  },

  footerRight: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    flex: 1,
  },

  pageNumberContainer: {
    backgroundColor: colors.primary,
    borderRadius: 15,
    padding: "4 12",
    minWidth: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  pageNumber: {
    fontSize: 9,
    color: colors.white,
    fontFamily: fonts.bold,
    textAlign: "center",
  },

  footerAccent: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 2,
    backgroundColor: colors.primary,
  },

  // Utility Styles
  horizontalLine: {
    backgroundColor: colors.primary,
    width: "100%",
    height: 2,
    marginVertical: 10,
    borderRadius: 1,
  },

  spacer: {
    height: 10,
  },
};
